import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { camelToWords } from '@/utils/stringHelper'
import ApplicationService from './application.service'

export const useApplication = () => {
  const baseCrud = useCrud(API_RESOURCE.APPLICATION, ApplicationService)
  const queryClient = useQueryClient()

  const useApproveApplication = () => {
    return useMutation({
      mutationFn: ApplicationService.approveApplication,
      onSuccess: (res) => {
        toast.info(`Successfully Approve ${camelToWords(ApplicationService.resource)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useRejectApplication = () => {
    return useMutation({
      mutationFn: ApplicationService.rejectApplication,
      onSuccess: (res) => {
        toast.info(`Successfully Reject ${camelToWords(ApplicationService.resource)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useFetchApplicationApprovals = (parameter) => {
    const { page, pageSize, sortBy = '', orderBy = 1, filters = {} } = parameter
    return useQuery({
      queryKey: [baseCrud.queryKey.list(parameter), 'approvals'],
      queryFn: () => ApplicationService.fetchApplicationApprovals(parameter),
      placeholderData: keepPreviousData,
    })
  }

  return {
    //Base CRUD
    useFetchAllApplications: baseCrud.useFetchAll,
    useFetchApplication: baseCrud.useFetchOne,
    useCreateApplication: baseCrud.useCreate,
    useUpdateApplication: baseCrud.useUpdate,
    useRemoveApplication: baseCrud.useRemove,

    //Extra

    useApproveApplication,
    useRejectApplication,
    useFetchApplicationApprovals,
  }
}
